module.exports = __webpack_public_path__ + "img/Flag_of_Burundi.08f6719e.svg";